interface Props {
  status: string;
  label: string;
}

export function StatusTag(props: Props) {
  return <span className={`status-tag status-${props.status.toLowerCase()}`}>{props.label}</span>;
}
